const app = {
    name: 'app',
    namespaced: true,
    state: {
        scrollStatus: new Date()
    },
    actions: {
        changeScrollStatus({ commit }, scrollStatus) {
            commit('SET_STATE', { scrollStatus });
        },
    }
};

export default app;
